module.exports = __webpack_public_path__ + "img/premium-tka-white.a4d17af5.svg";